import { render, staticRenderFns } from "./WeeklyReport.vue?vue&type=template&id=0edd1ccb&scoped=true&"
import script from "./WeeklyReport.vue?vue&type=script&lang=js&"
export * from "./WeeklyReport.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyReport.vue?vue&type=style&index=0&id=0edd1ccb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edd1ccb",
  null
  
)

export default component.exports